// extracted by mini-css-extract-plugin
export default {"mainView":"VrScreenDatePicker_mainView__Gw8+M","textInput":"VrScreenDatePicker_textInput__VoHRq","error":"VrScreenDatePicker_error__KxuU5"};